import { map, take } from 'rxjs/operators';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { getAnticipatedInvoiceState, OrderBuilderState } from '../../../../../reducers';
import { AnticipatedInvoiceSetAction } from '../../../actions/anticipated-invoice-actions/anticipated-invoice.actions';
import { IAnticipatedInvoiceState } from '../../../reducers/anticipated-invoice-reducer/anticipated-invoice.reducer';
import { ISalesDocument } from '@cemex-core/cmx-api/models/sales-document-management/';

@Injectable()
export class AnticipatedInvoiceSetCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: number): void {
    this.store
      .select(getAnticipatedInvoiceState)
      .pipe(
        take(1),
        map((state: IAnticipatedInvoiceState) => {
          return state.salesDocuments.find((salesDoc: ISalesDocument) => {
            return salesDoc.salesDocumentId === value;
          });
        }),
      )
      .subscribe((salesDoc: ISalesDocument) => this.store.dispatch(new AnticipatedInvoiceSetAction(salesDoc)));
  }
}
